import React, { useCallback, useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { sendResetPasswordEmail } from "../../../redux/auth/actions";
import { clearSpecificRequest } from "../../../redux/request/action";
import { SEND_RESET_PASSWORD_EMAIL } from "../../../redux/auth/actionType";
import ForgotPasswordPage from "./ForgotPasswordPage";

const ForgotPasswordPageContainer = () => {
  const dispatch = useDispatch();
  const request = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[SEND_RESET_PASSWORD_EMAIL],
  );

  const dispatchSendResetPasswordEmail = useCallback(
    (email: string) =>
      dispatch(sendResetPasswordEmail(email)),
    [dispatch]
  );

  useEffect(() => {
    dispatch(clearSpecificRequest(SEND_RESET_PASSWORD_EMAIL));
  }, [dispatch])

  const isSuccess = request?.didSucceed || request?.error.includes('There is no user record corresponding to this identifier.');
  const error = !request?.error.includes('There is no user record corresponding to this identifier.') && request?.error;

  return (
    <ForgotPasswordPage
      onSubmit={dispatchSendResetPasswordEmail}
      isLoading={request?.isLoading}
      error={error}
      isSuccess={isSuccess}
    />
  );
};

export default ForgotPasswordPageContainer;
